export enum KitsPages {
  about = 'about',
  hairmakeupkit = 'hairmakeupkit',
  skit = 'skit',
  mkit = 'mkit',
  wardrobekit = 'wardrobekit',
  workkit = 'workkit',
}
